import {request} from '../../helpers'

// ActionsUS 216
const ENTITY_ADS_ADD = 'ENTITY_ADS_ADD'
export function addAds(data)
{
    return request(ENTITY_ADS_ADD, 'post', '/add-ads', {data})
}
